<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフー覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <form class="container" v-on:submit="$router.push('/ubiadmin/AdminNewsConfirm')">
            <h1>ニュース登録</h1>
            <p class="title_txt">スタッフへ配信するニュースを登録または、編集してください。</p>
            <div class="admin_news_edit_wrap">
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p >タイトル</p>
                        <input v-model="news.title" placeholder="タイトルを入力してください。" type="text" maxlength="50" required />
                    </div>
                    <p class="input_txt">※50文字以内で入力してください。</p>
                </div>
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p>本文</p>
                        <textarea v-model="news.text" placeholder="本文を入力してください。" type="text" maxlength="250" required ref="area" :style="styles"></textarea>
                    </div>
                    <p class="input_txt">※250文字以内で入力してください。</p>
                </div>
                <div class="news_edit_box">
                        <p>添付ファイル</p>
                        <input placeholder="DFまたは、MP4ファイル" accept=".mp4,.pdf" type="file" class="file" readonly name="file" v-on:change="fileSelected">
                </div>
                <p class="input_txt">※PDFまたは、MP4ファイルを選択してください。</p>
                <div class="delivery_date_box">
                    <p>ニュース配信予約日時</p>
                    <input v-model="news.post_date" type="datetime-local" required />
                </div>
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p>メール送信用定型文</p>
                        <textarea v-model="news.template" placeholder="メール送信用定型文を入力してください。" type="text" maxlength="250" required ref="area" :style="styles"></textarea>
                    </div>
                    <p class="input_txt">※250文字以内で入力してください。</p>
                </div>
            </div>
            <div class="news_edit_btns">
                <button v-on:click="$router.back()" class="green_btn">戻る</button>
                <button class="green_btn" v-on:click="fileUpload">内容確認</button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    news: Object
  },
  data () {
    return {
      fileInfo: '',
      err_catch: false,
      url_protcol: 'https://',
      domain: '1304kanri.ubiquitous-p.com',
      url_path: '/rest/upload_file/',
      height: "100px"
    }
  },
  mounted(){
    this.resize();
  },
  methods: {
    fileSelected (event) {
      this.fileInfo = event.target.files[0]
    },
    fileUpload () {
      const formData = new FormData()
      formData.append('file', this.fileInfo)
      axios.post(this.url_protcol + this.domain + this.url_path, formData,{},{
          headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
      }).then(response => {
        this.news.file_data = response.data
      })
        .catch(error => {
          this.err_catch = true
          console.log(error)
        })
    },
    logout() {
        this.$store.commit('reset');
        this.$router.push({name:'aLogin'})
    },
    resize(){
        this.height = "100px";
        this.$nextTick(()=>{
        this.height = this.$refs.area.scrollHeight + 'px'
        })
    }
  },
  computed:{
    styles(){
        return {
            "height": this.height
        }
    }
  },
  watch:{
      news: {
          handler: function(){
              this.resize()
          },
          deep: true
      }        
  }
}
</script>

<style scoped>

.main {
    width: 100vw;
    height: 100vh;
    background-size: cover;
}

.container {
    width: 100vw;
    height: 93vh;
}

h1 {
    margin: 10px 30px;
}

p.title_txt {
    margin: 10px 30px;
}

.admin_news_edit_wrap {
    width: 90vw;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    padding: 30px 80px;
}

.news_edit_wrap {
    width: 70%;
    margin-top: 40px;
}

p.input_txt {
    color: #FF0202;
    font-size: .8em;
    text-align: right;
    margin-right: 20px;
}

.news_edit_box {
    display: flex;
    position: relative;
}

.news_edit_box p {
    width: 150px;
    line-height: 40px;
}

input, textarea {
    display: block;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

input.file {
    line-height: 37.5px;
}

textarea {
    resize: none;
    height: 100px;
    padding-top: 10px;
}

.delivery_date_box {
    border-top: 1px solid;
    margin-top: 30px;
    padding-top: 20px;
}

.delivery_date_box input {
    width: 60%;
}

label.choise_btn {
    display: block;
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #D7E37D;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    position: absolute;
    right: 20px;
    cursor:pointer;
}

input#file_upload {
    display: none;
}

.news_edit_btns {
    display: flex;
    justify-content: space-between;
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

button.red_btn, button.green_btn {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    border: none;
}

button.red_btn {
    background-color: #F37B6F;
    border: none;
    margin-right: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/AdminNewsEdit.vue